





























import Vue from 'vue'
import LoginForm from '@simpl/auth/components/LoginForm.vue'

export default Vue.extend({
  name: 'LoginDialog',

  components: { LoginForm },

  model: {},

  props: {
    value: Boolean,
    invertTextColor: Boolean,
    hideButton: Boolean,
    redirectUrl: String
  },

  data: () => ({
    forgotPassword: false
  }),

  computed: {
    show: {
      get (): boolean {
        return this.value
      },
      set (v: boolean) {
        this.$emit('input', v)
      }
    }
  }
})
